import Vue from 'vue'
import Vuetify from 'vuetify'

Vue.use(Vuetify, {
  iconfont: 'mdi', // 'md' || 'mdi' || 'fa' || 'fa4'
  theme: {
    primary: '#1976D2',
    secondary: '#26A69A',
    accent: '#1976D2', // #027be3
    error: '#DB2828',
    info: '#29B6F6',
    success: '#21BA45',
    warning: '#F2C037',
    tertiary: '#333',
    neutral: '#E0E1E2'
  }
})
